export default __webpack_public_path__ + "static/media/CFCLogo_Dark.405d35ac.png";